/** @jsx jsx */
import { jsx } from '@emotion/react'
import { Fragment } from 'react'
import { Parallax } from 'react-parallax';
import BgSection from "../assets/images/LP-kingdom/header-ensino-fundamental-ii.png";

import { HeaderSection } from '../assets/styles/AboutTwo.styles'

const HeaderTitleContent = () => {

  return (
    <Fragment>
      <Parallax bgImage={BgSection} bgImageAlt="Ensino Fundamental I" strength={100} style={{ transform: 'translate3d( 0%, 50px, 0px)' }}>
        <section css={HeaderSection}>
          <div className="div-align">
            <h1>Ensino Fundamental II</h1>
          </div>
          <div className="parallax-element"></div>
        </section>
      </Parallax>
    </Fragment>
  )
}

export default HeaderTitleContent;
